import { NodeNames, tosaErrorCodes as errorCodes } from '@farmersdog/constants';

import { ComponentName, LayoutType, NodeType } from '../../types';

import type { Fragment } from '../../types';

export const emailSentence = {
  name: 'emailSentence',
  type: NodeType.branch,
  layout: LayoutType.block,
  input: {
    excludeFromProgress: true,
  },
  children: [
    {
      name: NodeNames.Email,
      type: NodeType.leaf,
      validation: NodeNames.Email,
      layout: LayoutType.block,
      component: ComponentName.EmailInput,
      input: {
        label: 'My email address is %input%',
        accessibleLabel: 'Email address',
        placeholder: 'enter email',
      },
    },
    {
      name: 'emailError',
      type: NodeType.leaf,
      layout: LayoutType.block,
      component: ComponentName.InlineError,
      input: {
        errorMap: {
          [errorCodes.EMAIL_INVALID]:
            'This email doesn’t look right, please correct it.',
        },
        label: NodeNames.Email,
        excludeFromProgress: true,
      },
    },
  ],
} as const satisfies Fragment;
